import { render, staticRenderFns } from "./ClientAsset.vue?vue&type=template&id=4b52636c&scoped=true&"
import script from "./ClientAsset.vue?vue&type=script&lang=js&"
export * from "./ClientAsset.vue?vue&type=script&lang=js&"
import style0 from "./ClientAsset.vue?vue&type=style&index=0&id=4b52636c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52636c",
  null
  
)

export default component.exports